import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ImpactSection } from '../components/ImpactSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TeamSection } from '../components/TeamSection';
import { PartnershipsSection } from '../components/PartnershipsSection';
import { EventsSection } from '../components/EventsSection';
import { DonateSection } from '../components/DonateSection';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Home() {
  useDocumentMeta({
    title: 'Pancita Feliz Foundation | Transformando el Neurodesarrollo Familiar',
    description: 'Fundación dedicada a transformar la biología familiar para mejorar el neurodesarrollo. Educación, orientación y acceso a abordajes biomédicos para familias con pocos recursos.',
    path: '/'
  });
  return <>
      <HeroSection data-id="element-297" data-mp="30xb9e3tcoxwq" />
      <ProblemSection data-id="element-298" data-mp="30vqf8fay7gze" />
      <SolutionSection data-id="element-299" data-mp="30w05m3zwnq5m" />
      <ImpactSection data-id="element-300" data-mp="30uf9wb1uu166" />
      <LeadershipSection data-id="element-301" data-mp="2vx6qk74yzr3c" />
      <TeamSection data-id="element-302" data-mp="2vyq4hr35lq1y" />
      <PartnershipsSection data-id="element-303" data-mp="2vyhty5ui6wtx" />
      <EventsSection data-id="element-304" data-mp="2qylp64dzf1db" />
      <DonateSection data-id="element-305" data-mp="2qy2gzfe4vrch" />
    </>;
}